import { lazy } from 'react';

const AprrovedCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/aprroved-certification',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedCertificationConfig;

